// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--a_1Ev","container--disabled":"a10a3f92e9--container--disabled--quchJ","text":"a10a3f92e9--text--D_Q2d"};